// extracted by mini-css-extract-plugin
export default {"header":"ERjkxBZRUOEkJRzPazRS","inAngularContainer":"UFmocgLfNfuXu53oVUfx"};